import { CloseOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Flex, Form } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { formListAddFocus } from "../../../../../utils/form/form-list-add-focus.ts"
import type { TemplateDocumentFormData } from "../../../types/template-document-form-data.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface BulletListBlockProps {
  form: FormInstance<TemplateDocumentFormData>
  fieldKey: string
}

export function BulletListBlock({ form, fieldKey }: BulletListBlockProps) {
  const name = ["block_data", fieldKey, "items"]

  return (
    <>
      <Form.Item name={["block_data", fieldKey, "title"]} label="Section Title">
        <TextInput placeholder="e.g. Key Features" />
      </Form.Item>

      <Form.Item label="Items" required>
        <Form.List
          name={name}
          rules={[
            {
              validator: async (_, items) => {
                if (!items?.length) {
                  return Promise.reject(new Error("Add at least one item"))
                }
              }
            }
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <Flex id={name?.join("_")} vertical gap={8}>
              {fields.map((field) => (
                <Flex key={field.key} gap={8} align="start">
                  <Form.Item
                    name={[field.name]}
                    className="mb-0 flex-1"
                    rules={[{ required: true, whitespace: true, message: "" }]}
                  >
                    <TextInput placeholder={"Enter text"} />
                  </Form.Item>

                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      remove(field.name)
                      form.validateFields([name])
                    }}
                  />
                </Flex>
              ))}

              <Button
                type="dashed"
                onClick={() => {
                  formListAddFocus<TemplateDocumentFormData>(
                    () => add(""),
                    fields,
                    form,
                    name
                  )
                  form.validateFields([name])
                }}
                block
                icon={<PlusOutlined />}
              >
                Item
              </Button>

              <Form.ErrorList errors={errors} />
            </Flex>
          )}
        </Form.List>
      </Form.Item>
    </>
  )
}
